<template>
  <div class="withdraw-container">
    <div class="pc">
      <hm-content title :hidden="hidden">
        <div class>
          <div class="table-panel flex flex-between flex-wrap mb20 mt20">
            <!-- <div>
              <el-button type="primary" size="small" @click="batchAgree"
                >批量同意</el-button
              >
            </div> -->
            <div class="flex flex-wrap">
              <!-- <el-date-picker
                v-model="searchCondition.applyDate"
                type="daterange"
                align="right"
                start-placeholder="申请开始日期"
                end-placeholder="申请结束日期"
                value-format="yyyy-MM-dd"
                size="small"
                class="mr10"
              ></el-date-picker> -->
              <el-select
                size="small"
                clearable
                placeholder="选择状态"
                v-model="searchCondition.auditState"
                class="mr10"
                style="width: 200px"
                filterable
              >
                <el-option
                  v-for="(item, i) in statusList"
                  :key="i"
                  :label="item.name"
                  :value="item.objectId"
                ></el-option>
              </el-select>
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                class="mr10"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="searchCondition.applyDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="申请开始日期"
                end-placeholder="申请结束日期"
              ></el-date-picker>
              <el-input
                clearable
                v-model.trim="searchCondition.keyWord"
                placeholder="输入提现单号/会员姓名/电话号码"
                size="small"
                style="width: 222px"
                class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
              <el-button
                v-if="searchCondition.getcashType != 'weChat'"
                type="success"
                size="small"
                @click="output"
                :loading="isOutputing"
                >导出模板</el-button
              >
              <el-button type="success" size="small" @click="outputDetail"
                >生成报表</el-button
              >
            </div>
          </div>
          <div class="mb10">
            <el-radio-group
              v-model="searchCondition.getcashType"
              size="small"
              @change="cashTypeTab"
            >
              <el-radio-button label="weChat">微信提现</el-radio-button>
              <el-radio-button label="bank">银行卡提现</el-radio-button>
              <el-radio-button label="aliPay">支付宝提现</el-radio-button>
            </el-radio-group>
          </div>
          <div class="table">
            <el-table
              stripe
              border
              ref="brandTable"
              @selection-change="getChecked"
              :data="cashOutList.records"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                fixed
                type="selection"
                :selectable="checkboxT"
                width="40"
              ></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status success"
                    :class="scope.row.status"
                    v-show="scope.row.auditState === 'agree'"
                    >通过</span
                  >
                  <span
                    class="status blue"
                    :class="scope.row.status"
                    v-show="scope.row.auditState === 'wait'"
                    >待审核</span
                  >
                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.auditState === 'refuse'"
                    >驳回</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="提现单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberName"
                label="会员姓名"
              ></el-table-column>
              <el-table-column
                width="109"
                v-if="searchCondition.getcashType != 'weChat'"
                header-align="center"
                align="center"
                prop="alipayAccount"
                label="支付宝收款账号"
              ></el-table-column>
              <el-table-column
                  width="109"
                  v-if="searchCondition.getcashType === 'bank'"
                  header-align="center"
                  align="center"
                  prop="alipayAccount"
                  label="银行卡号"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.sourceApp == 'WOYAOHEXIAO' && scope.row.bankInfo"> {{ scope.row.bankInfo.bankCardNumber }}</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column
                  width="109"
                  v-if="searchCondition.getcashType === 'bank'"
                  header-align="center"
                  align="center"
                  prop="alipayAccount"
                  label="银行"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.sourceApp == 'WOYAOHEXIAO' && scope.row.bankInfo"> {{ scope.row.bankInfo.bankName }}</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberPhone"
                label="电话号码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="idcard"
                label="身份证号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcachApplyTime"
                label="申请时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashMoney"
                label="申请金额"
              >
                <template slot-scope="scope">
                  <div class="primary" v-if="scope.row.getcashMoney">
                    ¥{{ scope.row.getcashMoney }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackOrderSn"
                label="支付回执单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackStatus"
                label="支付结果状态"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.callbackStatus === 'success'"
                    class="success"
                  >
                    支付成功
                  </div>
                  <div
                    v-if="scope.row.callbackStatus === 'fail'"
                    class="danger"
                  >
                    支付失败
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackMsg"
                label="支付结果信息"
                width="200"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackReceiveAccount"
                label="付款账号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="驳回备注"
                width="200"
                :show-overflow-tooltip="true"
              >
                <!-- <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    :content="scope.row.refuseReason"
                    placement="top"
                  >
                  <div>
                     {{ scope.row.refuseReason }}
                  </div>

                  </el-tooltip>
                </template> -->
              </el-table-column>
              <!-- 已审核已驳回不显示 -->
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
                width="200"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="bill(scope.row)"
                      >个人账单</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      v-if="
                        searchCondition.getcashType === 'weChat' &&
                          scope.row.auditState === 'wait'
                      "
                      @click="details(scope.row)"
                      >查看</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="audit(scope.row)"
                      v-if="scope.row.auditState === 'wait'"
                      >通过</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      v-if="scope.row.auditState === 'wait'"
                      @click="reject(scope.row)"
                      >驳回</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="cashOutList.total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <el-dialog
          title="驳回备注"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-form
            label-width="80px"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item label="驳回原因" prop="refuseReason">
              <el-input
                maxlength="100"
                placeholder="请输入驳回原因，可直接选择下方模板"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="ruleForm.refuseReason"
              ></el-input>
            </el-form-item>
            <div class="reject-reason">
              <el-radio-group
                v-model="rejectReason"
                @change="switchRejectReason"
              >
                <div v-for="(v, i) in rejectTemp" :key="i">
                  <el-radio :label="i">{{ v }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
              @click="submitReject('ruleForm')"
              size="small"
              type="primary"
              >确认</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog>
        <el-dialog title="查看" :visible.sync="dialogVisibleDetails">
          <div class="wx-details">
            <div>交易时间：{{ wxDetails.transfer_time }}</div>
            <div>交易金额：{{ wxDetails.payment_amount }}</div>
            <div>交易单号：{{ wxDetails.detail_id }}</div>
          </div>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button @click="updateWx" size="small" type="primary"
              >更 新</el-button
            >
            <el-button @click="dialogVisibleDetails = false" size="small"
              >关 闭</el-button
            >
          </span>
        </el-dialog>
      </hm-content>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleBill"
      width="75%"
    >
      <el-radio-group v-model="type" size="small" @change="switchTab">
        <el-radio-button label="daoGou">导购账单</el-radio-button>
        <el-radio-button label="fenXiao">分销账单</el-radio-button>
        <el-radio-button label="withdraw">提现账单</el-radio-button>
        <el-radio-button label="recharge">充值账单</el-radio-button>
      </el-radio-group>
      <div class="modal-table mb20 mt10">
        <el-table stripe :data="[currentRow]" size="small">
          <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="姓名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberPhone"
            label="电话"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="idcard"
            label="身份证号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="所属商户"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="所属门店"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="allowGetcashMoneyAmount"
            label="可提现"
          >
            <template slot-scope="scope">
              {{ scope.row.allowGetcashMoneyAmount }}元
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="beingGetcashMoneyAmount"
            label="待发放"
          >
            <template slot-scope="scope">
              {{ scope.row.beingGetcashMoneyAmount }}元
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="hasGetcashMoneyAmount"
            label="已提现"
          >
            <template slot-scope="scope">
              {{ scope.row.hasGetcashMoneyAmount }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div v-if="type === 'daoGou'">
        <div class="modal-table mb20 mt10">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              所属门店商
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              所属门店
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              门店地址
            </div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ memberInfo.idcardName }}</div>
            <div class="flex-1">{{ memberInfo.authMobile }}</div>
            <div class="flex-1">{{ memberInfo.idcardNo }}</div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              {{ memberInfo.storeName }}
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              {{ memberInfo.shopName }}
            </div>
            <div class="flex-1" v-if="currentRoleType !== 'shareMember'">
              {{ memberInfo.shopAddress }}
            </div>
          </div>
        </div>
        <div class="mb20" v-if="currentRoleType !== 'shareMember'">
          已加入品牌: {{ memberInfo.hasJoinBrand }}
        </div>
        <div class="mb20" v-if="currentRoleType !== 'guider'">
          分销商城: {{ memberInfo.shareStore }}
        </div>
        <div class="mb20" v-if="currentRoleType !== 'shareMember'">
          工牌照片:
          <div style="width:100px;height:100px">
            <img :src="memberInfo.workCardImg" alt style="width:100%" />
          </div>
        </div>
        <div class="mb20" v-if="currentRoleType !== 'shareMember'">
          门店门头照片:
          <div style="width:100px;height:100px">
            <img :src="memberInfo.outletImg" alt style="width:100%" />
          </div>
        </div>
      </div> -->
      <div v-if="type === 'withdraw'">
        <!-- <div class="modal-table mb20 mt10">
          <div class="table-header flex mt10">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.memberName }}</div>
            <div class="flex-1">{{ currentRow.memberPhone }}</div>
            <div class="flex-1">{{ currentRow.idcard }}</div>
          </div>
        </div> -->
        <div class="table-panel flex flex-end">
          <div class="flex-1 text-right">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="withdrawConditions.getcashSn"
              placeholder="请输入提现单号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-date-picker
              v-model="withdrawConditions.getcachApplyTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择申请时间段"
              end-placeholder="选择申请时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-date-picker
              v-model="withdrawConditions.auditTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择审核时间段"
              end-placeholder="选择审核时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>

            <el-button
              type="primary"
              size="small"
              @click="queryWithDrawOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllWithDrawOrderList', '提现账单')"
              :loading="isOutputing"
              >导出</el-button
            > -->
          </div>
        </div>
        <div class="table">
          <el-table stripe border :data="widthDrawList" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="getcashSn"
              label="提现单号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.getcashSn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="getcachApplyTime"
              label="申请时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.getcachApplyTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditTime"
              label="审核时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.auditTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditUsername"
              label="审核人"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.auditUsername }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="提现金额"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.getcashMoney }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="widthDrawListTotal"
              @current-change="withDrawpaging"
              @size-change="handleWithDrawSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="withdrawCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else-if="type === 'daoGou'">
        <div class="table-panel flex flex-end" v-if="currentRow.guiderId">
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="declareTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择上传时间段"
              end-placeholder="选择上传时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryGuiderOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllGuiderOrderList', '导购账单')"
              :loading="isOutputing"
              >导出</el-button
            > -->
          </div>
        </div>
        <div class="table" v-if="currentRow.guiderId">
          <el-table stripe border :data="guiderList" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="declareSn"
              label="申报单号"
            >
              <template slot-scope="scope">
                <div
                  class="blue pointer"
                  @click="viewDetails(scope.row.declareSn)"
                >
                  {{ scope.row.declareSn }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptSn"
              label="小票号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptSn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="declareTime"
              label="申报时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.declareTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptTime"
              label="小票日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptDate }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="销售商品数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.goodsNum }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="总计收益"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.redpackageMoney }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    type="text"
                    @click="details(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="flex flex-end" style="fontSize:15px">
            当前页面的总计收益: <span class="primary"> {{ currentTotal }}</span
            >元
          </div>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="guiderListTotal"
              @current-change="guiderPaging"
              @size-change="handleGuiderSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="guiderCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="mt10 danger">
          还不是导购!
        </div>
      </div>
      <div v-else-if="type === 'fenXiao'">
        <!-- <div class="modal-table mb20 mt10">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.memberName }}</div>
            <div class="flex-1">{{ currentRow.memberPhone }}</div>
            <div class="flex-1">{{ currentRow.idcard }}</div>
          </div>
        </div> -->
        <div class="table-panel flex flex-end">
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="unlockTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择解锁时间段"
              end-placeholder="选择解锁时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryShareOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllShareOrderList', '分销账单')"
              :loading="isOutputing"
              >导出账单</el-button
            > -->
          </div>
        </div>
        <div class="table">
          <el-table stripe border :data="shareList" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptSn"
              label="订单号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptSn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payTime"
              label="付款日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.payTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="unlockTime"
              label="解锁日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.unlockTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="订单金额"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.actuallyPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalGoodsNum"
              label="订单商品数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.totalGoodsNum }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="所属商城"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.storeName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="总计收益"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.commissionPrice }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button size="small" type="text" @click="detail(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="shareListTotal"
              @current-change="shareListPaging"
              @size-change="handleShareListSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="shareOrderPageNo"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else-if="type === 'recharge'">
        <el-table stripe border :data="rechargeList" size="small">
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeSn"
            label="充值单号"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeSn }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeTime"
            label="充值时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeMoney"
            label="充值金额"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="充值状态"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.rechargeState === 'yes' ? 'success' : 'danger'
                "
                >￥{{
                  scope.row.rechargeState === "yes" ? "成功" : "失败"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeBeforeBalance"
            label="充值前金额"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeBeforeBalance }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeAfterBalance"
            label="充值后金额"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeAfterBalance }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="hm-pagination">
          <el-pagination
            background
            :total="rechargeListTotal"
            @current-change="rechargeListPaging"
            @size-change="handleRechargeListSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="rechargePageNo"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <div class="mobile">
      <div class="tabs flex flex-between">
        <div
          @click="switchTab(i)"
          class="tab"
          :class="{ active: activeTab === i }"
          v-for="(v, i) in tabList"
          :key="i"
        >
          {{ v.name }}
        </div>
      </div>
      <div class="scroll-content">
        <div class="control-panel flex">
          <div class="ipt-wrapper flex-1 flex item-center">
            <span class="icon hmicon icon-search"></span>
            <form @submit="search">
              <input
                type="search"
                ref="ipt"
                class="flex-1"
                placeholder="请输入导购名称/电话/单号"
                v-model="keywords"
              />
            </form>
          </div>
          <el-date-picker
            v-model="searchCondition.date"
            type="daterange"
            align="right"
            start-placeholder="申报开始时间"
            end-placeholder="申报结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </div>
        <ul class="list">
          <li
            v-infinite-scroll="load"
            class="list-item"
            @click="toDetails(v)"
            v-for="(v, i) in mobileList"
            :key="i"
          >
            <div class="flex flex-between item-center">
              <div class="flex item-center">
                <div class="tag">申报单号</div>
                <div class="user-info flex-1">{{ v.orderNo }}</div>
              </div>
              <div>
                提现金额：
                <span class="price">￥{{ v.price }}</span>
              </div>
            </div>
            <div class="info">
              <div>
                <span class="date gray">导购姓名：{{ v.guideName }}</span>
              </div>
              <div>
                <span class="date gray">申报日期：{{ v.date }}</span>
              </div>
            </div>
          </li>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      rechargePageSize: 10,
      rechargePageNo: 1,
      rechargeListTotal: 0,
      rechargeList: [],
      hidden: true,
      wxDetails: {},
      dialogVisibleDetails: false,
      loading: false,
      noMore: false,
      checkedRow: [],
      activeTab: 0,
      keywords: "",
      status: "",
      widthDrawList: [],
      widthDrawListTotal: 0,
      statusList: [
        {
          name: "通过",
          objectId: "agree"
        },
        {
          name: "驳回",
          objectId: "refuse"
        },
        {
          name: "待审核",
          objectId: "wait"
        }
      ],
      tabList: [
        {
          name: "待审核"
        },
        {
          name: "已审核"
        },
        {
          name: "已驳回"
        }
      ],
      auditState: "agreen",
      rejectReason: "",
      reason: "",
      dialogVisible: false,
      dialogVisibleBill: false,
      type: "daoGou",
      ruleForm: {
        refuseReason: ""
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        }
      },
      rows: {},
      isOutputing: false,
      list: [
        {
          orderSn: "6125615514",
          income: 548,
          status: "audit_pass"
        }
      ],
      searchCondition: {
        getcashType: "weChat",
        auditState: "wait"
      },
      withdrawConditions: {},
      unlockTime: [],
      title: "",
      guiderList: [],
      guiderListTotal: 0,
      declareTime: [],
      total: 10,
      currentPage: 1,
      pageSize: 10,
      shareOrderPageSize: 10,
      shareOrderPageNo: 1,
      guiderCurrentPage: 1,
      guiderPageSize: 10,
      withdrawPageSize: 10,
      withdrawCurrentPage: 1,
      shareList: [],
      shareListTotal: 0,
      rejectTemp: [],
      tabPosition: "all",
      mobileList: [],
      currentRow: {},
      currentTotal: 0
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore;
    },
    ...mapGetters(["cashOutList"])
  },
  watch: {},
  created() {
    this.queryList();
    this.queryDict();
  },
  methods: {
    viewDetails(declareSn) {
      let routeData = this.$router.resolve({
        name: "DetailsSalesVolumeNew",
        query: { declareSn }
      });
      window.open(routeData.href, "_blank");
    },
    cashTypeTab() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryDict() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: "getcash_audit_manual_template"
      });
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    checkboxT(row) {
      if (row.auditState === "wait") {
        return true;
      } else {
        return false;
      }
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },
    reject(row) {
      this.dialogVisible = true;
      this.rows = row;
    },
    switchTab(val) {
      if (val === "daoGou") {
        this.queryGuiderOrderList(this.currentRow);
      } else if (val === "fenXiao") {
        this.queryShareOrderList(this.currentRow);
      } else if (val === "withdraw") {
        this.queryWithDrawOrderList(this.currentRow);
      } else if (val === "recharge") {
        this.queryRechargeList(this.currentRow);
      }
    },
    async queryGuiderOrderList(row) {
      const { result } = await this.$store.dispatch("queryGuiderOrderList", {
        guiderId: row.guiderId,
        auditState: "agree",
        pageSize: this.guiderPageSize,
        pageNo: this.guiderCurrentPage,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length ? this.declareTime[1] : ""
      });
      const { records, total } = result;
      this.guiderList = records;
      let currentTotal = 0;
      this.guiderList.forEach(v => {
        currentTotal += v.redpackageMoney;
      });
      this.currentTotal = currentTotal;
      this.guiderListTotal = total;
    },
    async queryShareOrderList(row) {
      const { result } = await this.$store.dispatch("queryShareOrderList", {
        customerId: row.customerId,
        pageSize: this.shareOrderPageSize,
        pageNo: this.shareOrderPageNo,
        unlockStartTime: this.unlockTime ? this.unlockTime[0] : "",
        unlockEndTime: this.unlockTime ? this.unlockTime[1] : ""
      });
      const { records, total } = result;
      this.shareList = records;
      this.shareListTotal = total;
    },
    async queryRechargeList() {
      const { result } = await this.$store.dispatch("guiderRechargeRecord", {
        customerId: this.currentRow.customerId,
        pageSize: this.rechargePageSize,
        pageNo: this.rechargePageNo
      });
      const { records, total } = result;
      this.rechargeList = records;
      this.rechargeListTotal = total;
    },
    search() {
      this.queryList();
    },
    outputDetail() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";

      this.$store.dispatch("exoprtCashOutList", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.hidden = false;
      }, 0);
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCashOutList", params);
    },
    queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCashOutList", params);
    },
    getChecked(selection) {
      // this.checkedRow = selection.map(v => v.spuId);
      this.checkedRow = selection;
    },
    batchAgree() {
      if (this.checkedRow.length) {
        this.$confirm(`是否批量通过申请？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const searchCondition = JSON.parse(JSON.stringify(this.checkedRow));
          searchCondition.forEach(v => {
            v.auditState = "agree";
          });

          this.$store
            .dispatch("batchOpertaeCashOutList", searchCondition)
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功!",
                  type: "success"
                });
                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
                this.queryList();
              } else {
                this.queryList();
              }
            });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    async audit(row) {
      const result = await this.$confirm(`是否通过申请？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const searchCondition = JSON.parse(JSON.stringify(row));
        searchCondition.auditState = "agree";
        this.$store
          .dispatch("opertaeCashOutList", searchCondition)
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功!",
                type: "success"
              });
              this.queryList();
            }
          });
      }
    },
    async updateWx() {
      let params = JSON.parse(JSON.stringify(this.currentRow));
      params.callbackOrderSn = this.wxDetails.detail_id;
      const { code } = await this.$store.dispatch("cashOutUpdate", params);
      if (code === "0") {
        this.$message({
          message: "操作成功!",
          type: "success"
        });
        this.dialogVisibleDetails = false;
        this.queryList();
      }
    },
    async details(row) {
      this.currentRow = row;
      const { code, result } = await this.$store.dispatch("coinQueryMsg", row);
      if (code === "0") {
        this.wxDetails = result;
        this.dialogVisibleDetails = true;
      }
    },
    bill(row) {
      this.type = "daoGou";
      this.title = "个人账单";
      this.dialogVisibleBill = true;
      this.currentRow = row;
      this.queryGuiderOrderList(this.currentRow);
      // if (this.type === "daoGou") {

      //   this.queryGuiderOrderList(this.currentRow);
      // } else if (this.type === "fenXiao") {
      //   this.currentRow = row;
      //   this.queryShareOrderList(this.currentRow);
      // } else if (this.type === "withdraw") {
      // }
    },
    rechargeListPaging(page) {
      this.rechargePageNo = page;
      this.queryRechargeList(this.currentRow);
    },
    handleRechargeListSizeChange(size) {
      this.rechargePageNo = 1;
      this.rechargePageSize = size;
      this.queryRechargeList(this.currentRow);
    },
    shareListPaging(page) {
      this.shareOrderPageNo = page;
      this.queryShareOrderList(this.currentRow);
    },
    handleShareListSizeChange(size) {
      this.shareOrderPageNo = 1;
      this.shareOrderPageSize = size;
      this.queryShareOrderList(this.currentRow);
    },
    guiderPaging(page) {
      this.guiderCurrentPage = page;
      this.queryGuiderOrderList(this.currentRow);
    },
    handleGuiderSizeChange(size) {
      this.guiderCurrentPage = 1;
      this.guiderPageSize = size;
      this.queryGuiderOrderList(this.currentRow);
    },
    withDrawpaging(page) {
      this.withdrawCurrentPage = page;
      this.queryWithDrawOrderList(this.currentRow);
    },
    handleWithDrawSizeChange(size) {
      this.withdrawCurrentPage = 1;
      this.withdrawPageSize = size;
      this.queryShareOrderList(this.currentRow);
    },
    async queryWithDrawOrderList(row) {
      let params = {
        customerId: row.customerId,
        pageNo: this.withdrawCurrentPage,
        pageSize: this.withdrawPageSize
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      // withdrawConditions
      const { result } = await this.$store.dispatch(
        "queryWithDrawOrderList",
        params
      );
      const { records, total } = result;
      this.widthDrawList = records;
      this.widthDrawListTotal = total;
    },
    submitReject(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.auditState = "refuse";
          const searchCondition = JSON.parse(JSON.stringify(this.ruleForm));
          const params = JSON.parse(JSON.stringify(this.rows));

          Object.assign(params, searchCondition);

          this.$store.dispatch("opertaeCashOutList", params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.$message({
                message: "操作成功!",
                type: "success"
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.queryList();
            } else {
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.auditState = "";
      this.rejectReason = "";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    load() {},
    toDetails(v) {
      this.$router.push({
        name: "WithdrawDetails"
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then(res => {
            let list = res.result.records;

            list.forEach((v, i) => {
              v.index = i + 1;
            });
            let tHeader = [
              "序号",
              "收款方支付宝账号",
              "收款方姓名",
              "金额(元)",
              "备注"
            ];

            let filterVal = [
              "index",
              "alipayAccount",
              "memberName",
              "getcashMoney",
              "xxxx"
            ];

            let title = "支付宝批量付款模板";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss">
.sales-volumn-dialog {
  width: 800px;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
</style>
<style lang="scss" scoped>
.wx-details {
  > div {
    margin: 10px;
  }
}
.income {
  color: #e50065;
}
.title {
  width: 85px;
  text-align: right;
}
.modal-table {
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
}
@media screen and (max-width: 414px) {
  .withdraw-container {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      margin: -10px;
      font-size: 14px;
      .list {
        background: #fff;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .price {
          color: #f72b2b;
        }
        .tag {
          background: linear-gradient(
            180deg,
            rgba(112, 154, 247, 1),
            rgba(84, 135, 247, 1),
            rgba(43, 106, 247, 1)
          );
          color: #fff;
          font-size: 10px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }

      .tabs {
        background: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .tab {
          position: relative;
          &.active:after {
            content: "";
            position: absolute;
            bottom: -17px;
            left: 50%;
            width: 50%;
            transform: translateX(-50%);
            border-bottom: 4px solid #005ceb;
            border-radius: 30px;
          }
        }
      }

      .scroll-content {
        padding-bottom: 20px;
      }

      .control-panel {
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #f5f5f5;
        .ipt-wrapper {
          background: #f0f0f0;
          height: 34px;
          line-height: 34px;
          border-radius: 30px;
          border-bottom: 1px solid #f5f5f5;
          margin-right: 5px;
          padding-left: 10px;
          input {
            height: 34px;
            border: none;
            background: transparent;
            padding-left: 5px;
            font-size: 14px;
            &:focus {
              outline: none;
            }
          }
        }
      }

      .info {
        margin-top: 10px;
        line-height: 25px;
      }
    }
  }
}
@media screen and (min-width: 415px) {
  .withdraw-container {
    .pc {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
}
</style>
